export const humanize = (value = '') => String(value).replace(/_/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
export const isSecret = (name) => /password|private.?key|secret|config_url|^key$|access_token|refresh_token/i.test(name);
export const decodeText = (value) => String(value).replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&#x27;|&#39;/g, "'").replace(/&quot;/g, '"');

export const displayValue = (value, field = {}) => {
  if (value === null || value === undefined || value === '') return '—';
  const choice = field.attributes?.choices?.find((option) => String(option.value) === String(value));
  if (choice) return decodeText(choice.text);
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (field.type === 'datetime') {
    const date = new Date(value);
    if (!Number.isNaN(date.getTime())) return date.toISOString().replace('T', ' ').replace('.000Z', ' UTC').replace('Z', ' UTC');
  }
  if (Array.isArray(value)) return value.map((item) => displayValue(item)).join(', ');
  if (typeof value === 'object') return decodeText(value.value ?? value._label ?? value.symbol ?? JSON.stringify(value));
  return decodeText(value);
};

export const csvCell = (value) => {
  let text = String(value ?? '');
  if (/^[\s]*[=+@-]|^[\t\r\n]/.test(text)) text = `'${text}`;
  return `"${text.replace(/"/g, '""')}"`;
};

export const downloadText = (name, content, type = 'text/csv;charset=utf-8') => {
  const url = URL.createObjectURL(new Blob([content], { type }));
  const link = document.createElement('a');
  link.href = url; link.download = name; link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

export const editableValue = (value, field) => {
  if (value === null || value === undefined) return '';
  if (field?.type === 'foreign') return typeof value === 'object' ? value.id : value;
  if (field?.type === 'json') return typeof value === 'string' ? decodeText(value) : JSON.stringify(value, null, 2);
  if (field?.type === 'datetime') return new Date(value).toISOString().slice(0, 16);
  return typeof value === 'string' ? decodeText(value) : value;
};

export const formPayload = (values, fields) => Object.fromEntries(Object.entries(values).map(([name, value]) => {
  const field = fields[name] || {};
  // The admin backend's JsonSerialField accepts a JSON-encoded string, not an object.
  if (field.type === 'json') return [name, value === '' ? 'null' : JSON.stringify(JSON.parse(value))];
  if (field.type === 'datetime') return [name, value ? new Date(`${value}Z`).getTime() : null];
  if (value === '' && field.attributes?.nullable) return [name, null];
  return [name, value];
}));
